var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanksGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 345,
    viewBox: "0 0 516 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.762 87.6445)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 171.194,
    height: 85.5528,
    rx: 41,
    transform: "matrix(-1 0 0 1 430.121 87.6445)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.121 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.762 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.121 258.93)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.479 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 258.836 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 173.195 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.762 258.93)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.479 258.93)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 87.6406)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 171.194,
    height: 85.5528,
    rx: 41,
    transform: "matrix(-1 0 0 1 430.119 87.6406)",
    fill: "#43A047",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.119 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.119 258.926)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.477 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 258.836 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 173.193 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 258.926)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.477 258.926)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 2)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.119 2)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 258.836 258.926)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5223 258.445H131.717C154.36 258.445 172.717 276.802 172.717 299.445V302.998C172.717 325.642 154.36 343.998 131.717 343.998H42.5223C19.8786 343.998 1.52231 325.642 1.52231 302.998V299.445C1.52231 276.802 19.8787 258.445 42.5223 258.445Z",
    fill: "#43A047",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 87.6406)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 430.119 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 258.836 87.6406)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.477 2)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 515.76 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 344.477 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    rx: 41,
    transform: "matrix(-1 0 0 1 258.836 173.285)",
    fill: "#9BB7FF",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 85.5528,
    height: 85.5528,
    transform: "matrix(-1 0 0 1 173.193 173.285)",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksGraphic);
export default __webpack_public_path__ + "static/media/thanksGraphic.c54eb63aed9e7f8cc9760a97d979a770.svg";
export { ForwardRef as ReactComponent };